import { twMerge } from 'tailwind-merge';

const GradientBola = ({ color, ...props }: { color: string; className?: string }) => {
	return (
		<div {...props} className={twMerge('absolute left-1/2 -translate-x-1/2 -translate-y-[299px]', props.className)}>
			<div className={'w-[33vw] h-[517px] flex-shrink-0 rounded-full'} style={{ backgroundColor: color }} />
		</div>
	);
};

const Gradient = ({ colors }: { colors: string[] }) => {
	return (
		<div className='absolute left-0 top-0 size-full flex flex-row z-0 opacity-[0.13] blur-[89.5996px] !select-none !pointer-events-none'>
			<GradientBola color={colors[0]} className='ml-40' />
			<GradientBola color={colors[1]} />
			<GradientBola color={colors[0]} className='-ml-40' />
		</div>
	);
};

export default Gradient;
